import { render } from "./WorksList.vue?vue&type=template&id=1428a586"
import script from "./WorksList.vue?vue&type=script&lang=js"
export * from "./WorksList.vue?vue&type=script&lang=js"

import "./WorksList.vue?vue&type=style&index=0&id=1428a586&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__